module.exports = __webpack_public_path__ + "img/szjspx.c2ebb711.png";